import { Node } from 'reactflow';
import { HeatSourceTreeNode, ManifoldTreeNode, PipeStats, PumpTreeNode, TreeNodeWithChildren } from './treeNode';

export type HeatSourceMapNodeData = Omit<HeatSourceTreeNode['stats'], 'exitPipe'> &
  HeatSourceTreeNode['fieldData'] &
  CommonMapNodeData;

export type HeatSourceMapNode = Node<HeatSourceMapNodeData> & {
  type: MapNodeType.HeatSource;
};

export type ManifoldMapNodeData = ManifoldTreeNode['stats'] & ManifoldTreeNode['fieldData'] & CommonMapNodeData;

export type ManifoldMapNode = Node<ManifoldMapNodeData> & {
  type: MapNodeType.Manifold;
};

export type PipeMapNodeData = {
  parentTreeNode: TreeNodeWithChildren;
  isFirstChild: boolean;
  markedForDeletion: boolean;
} & PipeStats;

export type PipeMapNode = Node<PipeMapNodeData> & {
  type: MapNodeType.Pipe;
};

export type PumpMapNodeData = Omit<PumpTreeNode['stats'], 'exitPipe'> & PumpTreeNode['fieldData'] & CommonMapNodeData;

export type PumpMapNode = Node<PumpMapNodeData> & {
  type: MapNodeType.Pump;
};

type CommonMapNodeData = {
  treeNodeId: string;
  markedForDeletion: boolean;
};

export type MapNode = HeatSourceMapNode | ManifoldMapNode | PipeMapNode | PumpMapNode;

export enum MapNodeType {
  HeatSource = 'HEAT_SOURCE',
  Manifold = 'MANIFOLD',
  Pipe = 'PIPE',
  Pump = 'PUMP',
}
